import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ReactHookFormSelect2 } from 'common/components/form';

import * as configurationInsurancesActions from '../../../configurationInsurances/actions';
import * as configurationInsurancesSelectors from '../../../configurationInsurances/selectors';
import { buildCoverageOptions } from '../../helpers';

const AdditionalCoverage = ({ control, disabled }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const fetchCoverages = () =>
        dispatch(configurationInsurancesActions.fetchCoverages());

    const coverages = useSelector(
        configurationInsurancesSelectors.getCoveragesData,
    );

    const insuranceProductOptions = [
        { label: '', options: buildCoverageOptions(coverages) },
    ];

    useEffect(() => {
        fetchCoverages();
    }, []);

    return (
        <ReactHookFormSelect2
            control={control}
            disabled={disabled}
            label={t('Additional coverage')}
            name="insurance_product"
            options={insuranceProductOptions}
        />
    );
};

AdditionalCoverage.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
};

export default AdditionalCoverage;
